/**
 * M1 双语演示组件：语言切换器 + 回退提示 + 未审角标。
 * （真正的页面级 UI 随 M2 各内容页任务铺开；本文件保证 M1 三件机制可验证。）
 */
import { isUnreviewedEnglish, track, useLocale } from '../lib/locale';
import { copy } from '../lib/i18n';

/** 语言切换（两处挂载点行为一致：首页悬浮控件与内容页页头） */
export function LanguageSwitcher() {
  const { locale, switchTo } = useLocale();
  const next = locale === 'zh-CN' ? 'en' : 'zh-CN';
  return (
    <button
      type='button'
      className='lang-switcher'
      onClick={() => switchTo(next)}
      aria-label={copy('common.switchLanguage', locale)}
    >
      {locale === 'zh-CN' ? 'EN' : '中文'}
    </button>
  );
}

/** 动态内容缺失译文回退提示（不打扰的非阻断样式） */
export function LocaleFallbackNotice({ fallbackUsed }: { fallbackUsed: boolean }) {
  const { locale } = useLocale();
  if (!fallbackUsed) return null;
  return (
    <p className='locale-fallback-notice' role='status'>
      {locale === 'en'
        ? 'This content is not yet available in English; showing Chinese.'
        : '此内容暂无英文版本，已显示中文。'}
    </p>
  );
}

/** 英文未审角标（06 DraftBadge：首页草稿角标） */
export function DraftBadge({ text }: { text: string }) {
  const { locale } = useLocale();
  if (locale !== 'en' || !isUnreviewedEnglish(text)) return null;
  return <span className='draft-badge'>English draft · 未审核</span>;
}

export { track };
